package com.milta.core.localization.translations.nl

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Vernieuwen",
    expandedStopsTitle = "Stops",
    stopStatusWaitingLabel = "Wachtend",
    stopStatusFailedLabel = "Niet geleverd",
)
